import React from 'react';
import { useTranslation } from 'react-i18next';

function InputControl() {
  const { t } = useTranslation('common');

  return (
    <>
      <div className="custom-textarea ">
        <label className="field-lbl asterisk-req">
          {t('INPUT_LABEL.NOTE')}
          <span>*</span>
        </label>
        <textarea placeholder={t('INPUT_PLACEHOLDER.PLACEHOLDER')} className="form-control" rows="2" />

        <div className="text-count">0/200</div>
      </div>
      <small className="error-message">{t('ERROR_MESSAGE.REQUIRED')}</small>
    </>
  );
}

export default InputControl;
